import script from "./DeliveryContractorsRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryContractorsRow.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryContractorsRow.vue?vue&type=style&index=0&id=687dccbc&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-687dccbc"]])

export default __exports__